export default __webpack_public_path__ + "static/media/homeBG.b2457fdd.png";